define('views/comments/thread',[
  "globals",
  "backbone",
  "models/comments",
  "collections/comments",
  "views/comments/comment",
  "views/comments/reply"
], function (globals, Backbone, CommentModel, CommentList, CommentView, ReplyView) {
  "use strict";

  return Backbone.View.extend({
    tag: "div",
    className: "comment-thread",

    initialize: function () {
      if (_.has(globals, "content")) {
        this.listenTo(globals.content, "change:location", this.remove);
      }

      this.listenTo(this.model, "create:reply", this.renderReply);
    },

    render: function () {
      this.$el.append(new CommentView({
        model: this.model,
        collection: this.collection,
        id: "comment-" + this.model.id
      }).render().el);

      return this.renderReplies(this.model.get("replies"));
    },

    renderReplies: function (replies) {
      new CommentList(replies, { model: CommentModel }).each(function (reply) {
        this.renderReply(reply);
      }, this);

      return this;
    },

    renderReply: function (reply) {
      var replyView = new ReplyView({
        model: reply,
        collection: this.collection,
        id: "reply-" + reply.id
      });

      this.$el.append(replyView.render().el);

      return this;
    }
  });
});

